window.Popper = require('popper.js').default;
window.$ = require('jquery');
window.jQuery = require('jquery');

Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

import './scss/app.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import './libraries/jquery.transit.min.js'
window.buzz = require('./libraries/buzz.min.js')
import './libraries/flappy.js'

import 'es6-promise/auto'
import axios from 'axios'
import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import Router from "./routes"
import auth from './auth'
import App from './components/App.vue'

import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller, { locale: 'en' });

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueCardFormat from 'vue-credit-card-validation'
Vue.use(VueCardFormat)

import autosize from 'v-autosize/dist/plugin'

import i18n from './i18n'
import FunctionalCalendar from 'vue-functional-calendar'

import VueSvgGauge from 'vue-svg-gauge'
Vue.use(VueSvgGauge)

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
Vue.component('VueSlider', VueSlider)

import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
Vue.component('date-range-picker', DateRangePicker)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
MultiSelect.Inject(CheckBoxSelection);
Vue.use(MultiSelectPlugin);

import Carousel3d from 'vue-carousel-3d';
Vue.use(Carousel3d);

import {MediaQueries} from 'vue-media-queries';
const mediaQueries = new MediaQueries();
Vue.use(mediaQueries);


Vue.use(autosize);
Vue.config.productionTip = false

window.axios = axios
window.Vue = Vue
Vue.router = Router
Vue.use(VueRouter)
Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = `https://cursbackend.tbf.ro/api`
// Vue.axios.defaults.baseURL = `https://tbfdigitalbackend.atelieruldeit.ro/api`
// Vue.axios.defaults.baseURL = `http://localhost:3003/api`

Vue.use(VueAuth, auth)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.directive('click-outside',
{
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };

    document.body.addEventListener('click', el.clickOutsideEvent)
  },

  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

window.moment = require('moment');
window.moment.locale('ro');
window.moment.locale('ro', {
  relativeTime: {
    future: '+ %s',
  }
});

Vue.use(require("vue-moment"), {moment});
Vue.prototype.moment = moment;

Vue.use(FunctionalCalendar, {
    dayNames: moment.weekdaysMin(true),
    monthNames: moment.months(),
    shortMonthNames: moment.monthsShort()
});

Vue.mixin({
  data: function() {
    return {get globalTranslate() {return process.env.VUE_APP_VIEW_TRANSLATE == 'true'}}
  }
})

$(".description-dropdown").hover(function(){
  var dropdownMenu = $(this).children(".dropdown-menu");
  if(dropdownMenu.is(":visible")){
    dropdownMenu.parent().toggleClass("open");
  }
});

new Vue({
    router: Router,
    mediaQueries: mediaQueries,
    i18n,
    render: h => h(App)
}).$mount('#app')
